import isEmpty from 'lodash/isEmpty';
import { Meta } from '../../components/layout/Layout';

export const formatPageTitle = (title: string, brandName?: string) => {
  const delimiter: string = '|';
  let newTitle = brandName
    ? title.indexOf(`${delimiter} ${brandName}`) === -1
      ? `${title} ${delimiter} ${brandName}`
      : title
    : title;
  brandName && (newTitle = newTitle.replace(new RegExp(brandName, 'gi'), brandName));
  return newTitle;
};

/**
 * Clean alias by removing /targetjobs/ and /gradireland/ prefixes from URLs
 * @param href - The URL to clean
 * @returns Cleaned URL without the prefixes
 */
export const cleanAlias = (href: string): string =>
  href?.replace('/targetjobs/', '/')?.replace('/gradireland/', '/') || href;

export const getMetaTags = (
  meta: Array<any>,
  titleSuffix?: string,
  organisationName?: string,
  imageUrl?: string
): Array<Meta> => {
  const metaTags: Array<Meta> = meta.map((metatag: any) => {
    const content =
      metatag.attributes?.name?.toLowerCase() === 'title'
        ? formatPageTitle(
            `${metatag.attributes.content}${titleSuffix ? ` - ${titleSuffix}` : ''}${
              organisationName ? ` - ${organisationName}` : ''
            }`
          )
        : metatag.attributes.content;
    return {
      tag: metatag.tag,
      content: content,
      href: metatag.attributes.href,
      property: metatag.attributes.property,
      name: metatag.attributes.name,
      rel: metatag.attributes.rel
    };
  });

  // Handle removoing canonical tags if noindex is present
  let noIndex = false;
  let canonicalIndex;
  metaTags.forEach((value, index) => {
    if (!isEmpty(value.content) && value.content.includes('noindex')) {
      noIndex = true;
    }
    if (value.rel == 'canonical') {
      canonicalIndex = index;
    }
  });

  if (noIndex && canonicalIndex !== undefined) {
    delete metaTags[canonicalIndex];
  }

  if (imageUrl) {
    metaTags.push({
      tag: 'meta',
      name: '',
      property: 'og:image',
      content: imageUrl
    });
  }

  return metaTags;
};
